export default "__VITE_ASSET__Mf5CEk8KJAtVzjZdxeTP_A__";